/**
 * Set in the system browser of a computer that has the cubic desktop app. It records the device,
 * not the person, so it holds even while the browser is signed out.
 */
export const DESKTOP_DEVICE_COOKIE = 'cubic_desktop';

/** 'ask': offer to open eligible pages in the app. 'always': open them in the app without asking. */
export type DesktopDeviceMode = 'ask' | 'always';

const MAX_AGE_SECONDS = 400 * 24 * 60 * 60;

const COOKIE_PATTERN = new RegExp(`(?:^|;\\s*)${DESKTOP_DEVICE_COOKIE}=([^;]*)`);

/** The mode in a `Cookie` header or `document.cookie`, or null when this browser has none. */
export function parseDesktopDeviceMode(cookies: string | null): DesktopDeviceMode | null {
  const value = cookies?.match(COOKIE_PATTERN)?.[1];
  return value === 'ask' || value === 'always' ? value : null;
}

/**
 * The cookie that sets `mode`, for a `Set-Cookie` header or `document.cookie`. Page scripts read it,
 * so it is not HttpOnly; it holds no secret.
 */
export function serializeDesktopDeviceCookie(mode: DesktopDeviceMode): string {
  return `${DESKTOP_DEVICE_COOKIE}=${mode}; Path=/; Max-Age=${MAX_AGE_SECONDS}; SameSite=Lax; Secure`;
}

export function writeDesktopDeviceMode(mode: DesktopDeviceMode): void {
  document.cookie = serializeDesktopDeviceCookie(mode);
}
